export default function ReviewInputCN({ value, onChange, onSubmit, loading }) {
  return (
    <div className="reviewInput">
      <p  className="inputTitle">患者评论内容 :</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.();
        }}
      >
        <textarea
          name="textarea"
          rows="8"
          placeholder="请在此粘贴患者的评论。（例：医生很亲切，减肥效果也非常好！）"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={loading}
        />
        <button type="submit" className="submitbtn" disabled={loading}>
          {loading ? "创建中..." : "使用 AI 生成评论回复"}
        </button>
      </form>
    </div>
  );
}
